import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Stack, TextField, Button,
  useMediaQuery, useTheme,
} from '@mui/material';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import ModalHeader from '../ui/ModalHeader';
import { STATUS_LABELS } from '../../constants/status';

export function StatusChangeDialog({
  statusDialog, saving, onClose, onNoteChange, onConfirm,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={statusDialog.open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 3 } }}
    >
      <ModalHeader
        icon={<FlagOutlinedIcon fontSize="small" />}
        title={`เปลี่ยนสถานะเป็น ${STATUS_LABELS[statusDialog.toStatus] || statusDialog.toStatus}`}
        onClose={onClose}
        disabled={saving}
      />
      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={2}>
          <TextField
            label="หมายเหตุ" size="small" fullWidth multiline rows={2}
            value={statusDialog.note}
            onChange={(e) => onNoteChange(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={saving}>ยกเลิก</Button>
        <Button onClick={onConfirm} variant="contained" disabled={saving} sx={{ borderRadius: 2 }}>
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default StatusChangeDialog;
